// The information contained in this document are the sole property of LivingPackets. Any disclosure to any third party and any reproduction, in part or whole without the written permission of LivingPackets is prohibited
// Confidential - Copyright LivingPackets: All rights reserved

import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

import { ClosureRequest } from '../types';
import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { QueryConfig } from '@/lib/react-query';

type MakeRequestType = ReturnType<typeof useImperativeRequestWrapper>[1];

export const getClosureRequest = async ({
  partnerId,
  makeRequest,
}: {
  partnerId: string;
  makeRequest: MakeRequestType;
}): Promise<ClosureRequest | null> => {
  const { data, error } = await makeRequest({
    path: `/partners/${partnerId}/closure-request`,
  });

  // Not found ==> no closure request
  if (error && error.status === 404) {
    return null;
  }

  if (error) {
    throw new Error(error?.message ?? String(error));
  }

  return data;
};

type QueryFnType = typeof getClosureRequest;

type UsePartnerClosureRequestOptions = {
  partnerId?: string;
  config?: QueryConfig<QueryFnType>;
};

export const usePartnerClosureRequest = ({
  partnerId,
  config,
}: UsePartnerClosureRequestOptions = {}) => {
  const { id: routePartnerId } = useParams<{ id: string }>();
  const resolvedPartnerId = partnerId ?? routePartnerId;

  const [, makeRequest] = useImperativeRequestWrapper('lpVillageV3');

  return useQuery({
    enabled: !!resolvedPartnerId,
    ...config,
    queryKey: ['partners', resolvedPartnerId, 'closure-request'],
    queryFn: () =>
      getClosureRequest({
        partnerId: resolvedPartnerId as string,
        makeRequest,
      }),
  });
};
